import { createCtx } from "utils/react"
import { PalletContext } from "utils/router"

export const [usePalletContext, PalletContextProvider] =
    createCtx<PalletContext>()
